import React from 'react';
import PageBanner from 'components/banners/PageBanner';
// import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';

function IDScanner() {
  return (
    <div>
      <Helmet>
        <title>Id Card Scanner - CAP60</title>
        <meta
          name="description"
          content="Any state-issued ID is read by the ID card scanner, and the information from the ID is auto-populated. Saves valuable time for Case workers and increases accuracy!"
        />
        <meta name="keyword" content="id card scanner, cap60 id card scanner" />
      </Helmet>
      <PageBanner
        title="Auto-fill your Intake form"
        subtitle="With CAP60’s ID Card Scanner"
      />
      <ClienDesk />
      <div className="floralbg-blue">
        {/* <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
            itemClass={styles.featureItem}
          />
        </Container> */}
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>
                Want to change a ten-minute client intake process to one minute?
              </h2>
            </div>
            <p>
              Then the ID Card scanner is for you. It’s easy to install and easy
              to use. The ID card scanner reads any state issued ID and
              auto-populates those fields. Saves valuable time for Case workers
              and increases accuracy!
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image src={'/images/id-scanner.png'} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default IDScanner;
